import { APIRecipeNutrition } from '@mindfulchefuk/features/Recipes/interfaces'

interface Parameters {
  macrosLookup: {
    [key: number]: APIRecipeNutrition
  }
  portionSize: number
}

const currentMacros = ({
  macrosLookup,
  portionSize,
}: Parameters): APIRecipeNutrition => macrosLookup[portionSize]

export default currentMacros
